export const SUCCESS = 200;
export const CREATED = 201;
export const USERNOTFOUND = 437;
export const INVALIDPASSWORD = 433;
export const UNAUTHORIZED = 401;
export const ALREADYEXISTS = 435;
export const NOCONTENT = 204;
export const INTERNAL_SERVER_ERROR = 500;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
